// This module expects to receive a jsconn object
// it checks to see if the billing account has an issue
const checkBillingAccount = (jsConn) => {
  // is the jsconn already halted?
  if (jsConn.halted) {
    return Promise.reject(jsConn)
  }

  // is the response in the response or error property
  if (jsConn.apiCallStatus === 'success') {
    // the api call was a success
    if (jsConn.response['data']['status'] === 'billing account issue') {
      // redirect to the billing account page
      // halt the connection
      jsConn.toRoutePath = '/billing-account-issue'
      jsConn.halted = true

      return Promise.reject(jsConn)
    } else {
      return Promise.resolve(jsConn)
    }
  } else {
    return Promise.resolve(jsConn)
  }
}

export { checkBillingAccount }
